<template>
  <div class="tt-footer">
    <div class="footer">
      <div class="left">
        <p class="text">365x24小时服务热线</p>
        <p class="tell">0755-83015888</p>
      </div>
      <div class="right tt-tac">
        <p class="text">
          Android 客户端下载
          <br />
          <br />
          <img class="code-img" width="100px" :src="require('@img/download-android.png')" alt />
        </p>
        <p class="text">
          IOS 客户端下载
          <br />
          <br />
          <img class="code-img" width="100px" :src="require('@img/download-ios.png')" alt />
        </p>
      </div>
    </div>
    <div class="tt-container">
      <div class="copyright">Copyright©2019 深圳市天泰网络技术有限公司 版权所有.<a target="_blank" class="tt-orange tt-link" href="https://beian.miit.gov.cn">粤ICP备17035665号</a></div>
      <div>
        <span />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pagefooter'
}
</script>
<style lang="less" scoped>
.footer {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #212121;
    font-size: 16px;
    margin-bottom: 15px;
  }
  .left {
    width: 45%;
    border-right: 1px solid #d8d8d8;
    .tell {
      font-size: 32px;
      color: #ff9100;
      margin-bottom: 35px;
    }
    .code-img {
      width: 120px;
      height: 120px;
    }
  }
  .right {
    display: flex;
    width: 55%;
    justify-content: space-around;
  }
}
.tt-footer {
  padding: 40px 0 20px;
  color: #98a1b3;
  font-size: 14px;
  background-color: transparent;
  text-align: center;
}
.hotline {
  line-height: 50px;
}
.hotline span a {
  color: #98a1b3;
  border-right: 1px solid #98a1b3;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue